import appFeatures from '../app-features'
import { mapState } from 'vuex'
import _ from 'lodash'

export const userInfoMixin = {
  computed: {
    ...mapState('login', {
      loggedInUser: 'user',
      activeLocation: 'activeLocation'
    }),
    hasCompanyRole () {
      return this.isGranburyUser || this.loggedInUser.grantedRoles.some(role => role.grantedOn.type === 'GLOBAL')
    },
    userCompanyId () {
      return _.get(this.loggedInUser, 'userCompanyId')
    },
    userCompanyName () {
      return _.get(this.loggedInUser, 'userCompanyName')
    },
    enabledFeatures () {
      return _.get(this.loggedInUser, 'enabledFeatures', [])
    },
    accessibleTenants () {
      return _.get(this.loggedInUser, 'accessibleTenants', [])
    },
    isEngineeringUser () { return this.hasFeature(appFeatures.engineeringUser) },
    isGranburyUser () { return this.hasFeature(appFeatures.granburyUser) },
    isGranburyCompanyActive () { return this.userCompanyId === this.granburyCompanyId }
  },
  data () {
    return {
      granburyCompanyId: '79e29a4c-9644-42cd-b9bb-7d998114d892',
      appFeatures
    }
  },
  methods: {
    hasFeature (feature) {
      return this.enabledFeatures.includes(feature)
    },
    isGranburyCompany (company) {
      return company.id === this.granburyCompanyId
    },
    hasTOL () {
      return this.hasFeature(appFeatures.tolLicense)
    }
  }
}

export default userInfoMixin
